<template>
    <div style="height: 100%">
        <ContainerCybo
            v-if="pageTheme === 'CYBO'"
            :hashcode="hashcode"
            :main-state="mainState"
            :is-mobile="isMobile"
            :path-to-png="pathToPng"
        ></ContainerCybo>

        <ContainerCyboDark1
            v-if="pageTheme === 'CYBO_DARK_1'"
            :hashcode="hashcode"
            :main-state="mainState"
            :is-mobile="isMobile"
            :path-to-png="pathToPng"
        ></ContainerCyboDark1>
    </div>
</template>

<script>
    import i18n from '../services/language.service'

    import ContainerCyboDark1 from './themes/cyboDark1/ContainerCyboDark1'
    import ContainerCybo from './themes/cybo/ContainerCybo'

    export default {
        name: 'DownloadPageContainer',
        data() {
            return {
                hashcode: '',
                type: '',
                theme: '',
                mainState: 0,
                window: {
                    width: 0,
                    height: 0
                },
                currentLanguage: 'en',
                languages: [
                    {
                        flag: 'gb',
                        language: 'en',
                        title: 'EN'
                    },
                    {
                        flag: 'de',
                        language: 'de',
                        title: 'DE'
                    }
                ]
            }
        },
        methods: {
            handleResize: function () {
                this.window.width = window.innerWidth
                this.window.height = window.innerHeight
            },
            changeLanguage: function (locale) {
                i18n.locale = locale
                this.currentLanguage = locale
            }
        },
        computed: {
            isMobile: function () {
                return this.window.width < 900
            },
            pathToPng: function () {
                return this.$payload.HOSTNAME + '/download/png/' + this.hashcode
            },
            pageTheme: function () {
                switch (this.theme) {
                    case 'THEME_VOLLCORNER':
                        return 'VOLLCORNER'
                    case 'THEME_CYBO_DARK_1':
                        return 'CYBO_DARK_1'
                    case 'THEME_CYBO':
                    default:
                        return 'CYBO'
                }
            }
        },
        created() {
            window.addEventListener('resize', this.handleResize)
            this.handleResize()

            this.hashcode = this.$route.query.id
            this.type = this.$route.query.t

            if (this.hashcode === undefined) {
                this.mainState = -1
                return
            }

            let context = this
            this.$http
                .get(this.$payload.HOSTNAME + '/checkHashcode?bonid=' + this.hashcode)
                .then(function (response) {
                    if (response.status === 200 && response.data.status.value === 100) {
                        context.mainState = 2
                        context.theme = response.data.body.theme

                        context.$http
                            .post(context.$payload.HOSTNAME + '/setPageVisited', {
                                hashcode: context.hashcode
                            })
                            .then(function (response) {
                                if (response.status !== 200) {
                                    console.log('error while setting page visited')
                                }
                            })
                            .catch(function (err) {
                                console.log('error while setting page visited')
                                console.log(err)
                            })

                        if (context.type) {
                            context.$http
                                .post(context.$payload.HOSTNAME + '/setPageAction', {
                                    hashcode: context.hashcode,
                                    action: context.type
                                })
                                .then((response) => {
                                    if (response.status !== 200) {
                                        console.log('error while setting page action')
                                    }
                                })
                                .catch((err) => {
                                    console.log('error while setting page action')
                                    console.log(err)
                                })
                        }
                    } else {
                        context.mainState = 1
                    }
                })
                .catch(function () {
                    console.log('error')
                    //console.log(err);
                    context.mainState = -2
                })
        },
        destroyed() {
            window.removeEventListener('resize', this.handleResize)
        },
        components: {
            ContainerCybo,
            ContainerCyboDark1
        }
    }
</script>

<style scoped></style>